t = require('app/scripts/views/internal/teacup-with-helpers')('header_promo_nav')
socialUrls = require('locale').social

module.exports = ->
  t.nav '.promo-nav', ->
    t.a '.promo-nav-button', { href: '/' }, ->
      t.format 'home'
    t.a '.promo-nav-button', { href: '/tour' }, ->
      t.format 'tour'
    t.a '.promo-nav-button', { href: socialUrls.blog, target: '_blank' }, ->
      t.format 'blog'
